import { useParams } from "react-router-dom";
import { useFeedback } from "../../../contexts/FeedbackContext";
import { usePlugin } from "../contexts/PluginContext";
import { useFetch } from "../../../hooks/useFetch";
import { useLocalization } from "../../../contexts/LocalizationContext";
import { apiRoutes } from "../../../apiRoutes";
import { useCallback, useState } from "react";
import { PluginLog } from "../models/PluginLog";

export const useLogs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<PluginLog[]>([]);
  const { handleLoadingChange, getPlugin } = usePlugin();
  const { pushNotification, showModal } = useFeedback();
  const params = useParams();
  const { request } = useFetch();
  const { translate } = useLocalization();
  const { pluginId } = useParams() as { pluginId: string };

  const getLogs = useCallback(
    async (id?: number) => {
      setIsLoading(true);

      await request({
        route: apiRoutes.logs.getLogsByPluginId(id ?? parseInt(pluginId)),
        onSuccess: async (response) => setData(await response.json()),
        onAny: () => setIsLoading(false)
      });
    },
    [request, pluginId]
  );

  const handleClearAll = () => {
    const pluginId = parseInt(params.pluginId as string);
    const handleContinue = async () => {
      showModal(null);
      handleLoadingChange(true);
      await request({
        route: apiRoutes.logs.clearAllPluginLogs(pluginId),
        method: "DELETE",
        onSuccess: async () => {
          await getPlugin();
          pushNotification({ message: translate("plugins.removedPluginLogs"), type: "success" });
        },
        onFailure: async (response: Response) => {
          const json = await response.json();
          pushNotification({ ...json, type: "danger" });
        },
        onAny: () => handleLoadingChange(false)
      });
    };

    showModal({
      isVisible: true,
      message: translate("plugins.removeAllPluginLogs"),
      handleClose: () => showModal(null),
      handleContinue
    });
  };

  return { data, isLoading, getLogs, handleClearAll };
};
